import { ModalComponent } from "..";
import {
  useRejectMembershipInviteMutation,
  useToggleAcceptOfficialInviteMutation,
} from "../../../redux/features/cooperative/cooperative.api";
import {
  SingleCooperative,
  SingleCooperativeInvite,
} from "../../../redux/features/cooperative/cooperative.type";

export const DeclineInvitationModal = ({
  isModalOpen,
  onModalClose,
  cooperative,
  invitation,
  onSuccess,
}: {
  isModalOpen: boolean;
  onModalClose: () => void;
  cooperative?: SingleCooperative;
  invitation?: SingleCooperativeInvite;
  onSuccess: () => void;
}) => {
  // const { rejectMembershipInvite, fetchInvitations, rejectOfficialInvite } =
  //   useMembership();

  const [rejectMemberInvite, { isLoading: rejectingMemberInvite }] =
    useRejectMembershipInviteMutation();
  const [toggleOfficialInvite, { isLoading: rejectingOfficialInvite }] =
    useToggleAcceptOfficialInviteMutation();

  return (
    <ModalComponent
      isModalOpen={isModalOpen}
      onModalClose={onModalClose}
      title="Decline Invitation"
      subTitle={
        <div>
          You are about to decline this invitation from{" "}
          <span className="text-pry-green-200">{cooperative?.CoopName}</span>.{" "}
        </div>
      }
      childrenClassName=""
      modalClassName=""
      hasButtons
      proceedButtonText="Yes, Decline"
      proceedButtonVariant="danger"
      onProceedClick={async () => {
        if (invitation?.InvitationAction === "official") {
          const resp = await toggleOfficialInvite({
            coop: invitation?.Cooperative?.id,
            isAccept: false,
          });

          if (resp.data?.success) {
            onSuccess();
          }
        } else {
          const resp = await rejectMemberInvite({
            coop: invitation?.Cooperative?.id!,
            answer: false,
          });

          if (resp.data?.success) {
            onSuccess();
          }
        }
      }}
      hasCancelButton
      cancelButtonText="No, Don't decline"
      cancelButtonVariant="primary"
      onCancelClick={() => {
        onModalClose();
      }}
      isLoading={rejectingMemberInvite || rejectingOfficialInvite}
      isProceedDisabled={rejectingMemberInvite || rejectingOfficialInvite}
    />
  );
};
